import React from 'react';
import { Outlet } from 'react-router-dom';
import { Button } from '@mui/material';
import '../../styles/templates/LoginTemplate.scss';

const LoginTemplate: React.FC = () => {
  const versao: string = '1.0.0'; // You can get this from environment or package.json

  return (
    <section className="login-template">
      <div className="logotipo-login">
        <img src="/assets/icons/icon-152x152.png" alt="Logo" />
      </div>

      <Outlet />

      <div className="legal">
        <Button 
          component="a" 
          href="https://api.bneinoach.org.br/termos-de-uso"
          size="small"
          sx={{ fontSize: '7px', padding: '0 5px' }}
        >
          Termos de uso
        </Button>
        <Button 
          component="a" 
          href="https://api.bneinoach.org.br/termos-de-uso"
          target="_blank"
          size="small"
          sx={{ fontSize: '7px', padding: '0 5px' }}
        >
          Políticas de privacidade
        </Button>
        <Button 
          size="small"
          sx={{ fontSize: '7px', padding: '0 5px' }}
        >
          Versão {versao}
        </Button>
      </div>
    </section>
  );
};

export default LoginTemplate; 